const pkg = require('../../package.json');

export const HEADER_STORE_CODE = 'X-STORE-CODE';


// Default configuration
export let config = {
    mock: false,
    noPolling: false,
    // application_name: process.env.npm_package_name,
    application_name: pkg.name,
    application_version: pkg.version,
    application_revision: process.env.APP_REVISION,
    features: {
        FEATURE_GOOGLE_DIRECTIONS: false,
    }
}


if (process.env.REACT_APP_ENV === "staging") {
    Object.assign(config, {
        brokerURL: 'wss://deliverytracker-tst-api.factsandit.mindera.com/websocket',
        homeUrl: 'https://deliverytracker-tst-api.factsandit.mindera.com/login?return_url=https://deliverytracker-tst-web.factsandit.mindera.com',
        apiUrl: 'https://deliverytracker-tst-api.factsandit.mindera.com',
        googleMapsKey: 'AIzaSyACSTziajqv24WVnHxi7F9Ws8b5q-nAnnQ',
    });

} else if (process.env.REACT_APP_ENV === "production") {
    Object.assign(config, {
        // production
        brokerURL: 'wss://deliverytracker-prod-api.factsandit.mindera.com/websocket',
        homeUrl: 'http://192.168.86.112/GOAL',
        apiUrl: 'https://deliverytracker-prod-api.factsandit.mindera.com',
        googleMapsKey: 'AIzaSyCYc6ShCeHzO4hHINQChwSomCKcU3NN-LQ',
    });
} else {
    Object.assign(config, {
        // Local
        mock: true,
        brokerURL: 'ws://localhost:8090/websocket',
        homeUrl: 'http://localhost:8090/login?return_url=http://localhost:9090',
        apiUrl: 'http://localhost:8090',

        // brokerURL: 'wss://deliverytracker-tst-api.factsandit.mindera.com/websocket',
        // homeUrl: 'https://deliverytracker-tst-api.factsandit.mindera.com/login?return_url=https://deliverytracker-tst-web.factsandit.mindera.com',
        // apiUrl: 'https://deliverytracker-tst-api.factsandit.mindera.com',

        googleMapsKey: 'AIzaSyACSTziajqv24WVnHxi7F9Ws8b5q-nAnnQ',
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js